/**
 * scene.js - Three.js Scene, Camera, Renderer, Lights
 */
import * as THREE from "three";
import { applyUrlParams, urlSettings } from "./urlParams.js";

// URL-Parameter SOFORT auslesen (vor allem anderen!)
applyUrlParams();

// Hintergrundfarbe aus URL oder Default
const bgColor = urlSettings.background || "black";

// Scene
export const scene = new THREE.Scene();
scene.background = new THREE.Color(bgColor);

// Camera
export const camera = new THREE.PerspectiveCamera(
  75,
  window.innerWidth / window.innerHeight,
  0.1,
  500
);
camera.position.z = 1;

// Renderer
const canvas = document.querySelector("canvas.webgl");
export const renderer = new THREE.WebGLRenderer({ canvas, stencil: true });
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setPixelRatio(window.devicePixelRatio);
// Clear-Color auf gleiche Farbe wie Scene-Background setzen (verhindert Flackern beim Laden)
renderer.setClearColor(new THREE.Color(bgColor), 1);

// Clock
export const clock = new THREE.Clock();

// Lights
export let ambientLight = null;
export let directLight = null;
export let pointLight1 = null;

export function setupLights() {
  ambientLight = new THREE.AmbientLight("white", 1);

  directLight = new THREE.DirectionalLight("white", 2);
  directLight.position.set(0, 20, 0);

  pointLight1 = new THREE.PointLight(0xffffff, 2);
  pointLight1.position.set(0, 0, 0.7);
  pointLight1.visible = false;

  scene.add(ambientLight, directLight, pointLight1);
}

// Resize Handler
export function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
}

/**
 * Passt die Kamera-Position an, damit ein Objekt mit gegebener Breite sichtbar ist
 * @param {number} objectWidth - Breite des Objekts in World-Units
 * @param {number} padding - Zusätzlicher Abstand (1.0 = kein Padding, 1.2 = 20% Padding)
 */
export function adjustCameraForWidth(objectWidth, padding = 1.2) {
  const aspect = window.innerWidth / window.innerHeight;
  const fov = camera.fov * (Math.PI / 180); // In Radians

  // Berechne benötigte Z-Distanz basierend auf Breite und FOV
  // Bei Landscape: Breite ist limitierend
  // Bei Portrait: Höhe ist limitierend (daher aspect berücksichtigen)

  let distance;
  if (aspect >= 1) {
    // Landscape oder Quadrat: Breite passt, prüfe ob Höhe auch passt
    const distanceForWidth = (objectWidth * padding / 2) / Math.tan(fov / 2) / aspect;
    const distanceForHeight = (objectWidth * padding / 2) / Math.tan(fov / 2);
    distance = Math.max(distanceForWidth, distanceForHeight * 0.5);
  } else {
    // Portrait: Mehr Abstand nötig da schmaler
    distance = (objectWidth * padding / 2) / Math.tan(fov / 2) / aspect;
  }

  // Minimum und Maximum begrenzen
  camera.position.z = Math.max(0.8, Math.min(distance, 5));
}
